export function getTranslation(lang: string): {
    advancedDetails: string;
    loanAssumptions: string;
    purchase: string;
    refinanceCashOut: string;
    refinance: string;
    primaryResidence: string;
    purchasePrice: string;
    currentHomeValue: string;
    downPayment: string;
    refinanceAmount: string;
    customizeRate: string;
    todaysRate: string;
    detailedQuote: string;
    per: string;
    month: string;
    onApprovedCredit: string;
    includePropertyTax: string;
    includeInsurance: string;
    updateResults: string;
    paymentClosingCosts: string;
    principalAndInterest: string;
    taxes: string;
    insurance: string;
    applyLoanOnline: string;
    meetWithMortgageExpert: string;
    meetWithMortgageExpertToLearnMore: string;
    totalClosingCosts: string;
    lenderFees: string;
    loanOriginationFee: string;
    processingFee: string;
    mortgagePoints: string;
    thirdPartyCosts: string;
    creditReportFee: string;
    titleFees: string;
    appraisal: string;
    constructionInspectionFees: string;
    itemsDueAtClosing: string;
    interestPartialMonth: string;
    homeOwnersInsurance: string;
    propertyTaxes: string;
    tbd: string;
    apply: string;
    NationalGuardOrReserves: string;
    ActiveDuty: string;
    apr: string;
    loanType: string;
    adjustYourRate: string;
    rate: string;
    otherLoanTypesAvailable: string;
    totalEstClosingCosts: string;
    onlineQuoteNotFound: string;
    rateError: string;
} {
    const translationStrings = {
        en: {
            advancedDetails: 'Advanced Details',
            loanAssumptions: 'Loan assumptions',
            Purchase: 'Purchase',
            RefiCashout: 'Refinance Cash Out',
            RefiRateTermLimitedCO: 'Refinance',
            InvestmentProperty: 'Investment Property',
            PrimaryResidence: 'Primary Residence',
            SecondHome: 'Second Home',
            Condo: 'Condo',
            SingleFamily: 'Single Family',
            Townhouse: 'Townhouse',
            purchasePrice: 'Purchase price',
            currentHomeValue: 'Current home value',
            downPayment: 'Down payment',
            refinanceAmount: 'Refinance amount',
            customizeRate: 'Customize your rate',
            todaysRate: "Today's rate",
            detailedQuote: 'See detailed quote',
            per: 'Per',
            month: 'Month',
            onApprovedCredit: 'On approved credit',
            includePropertyTax: 'Include property tax (estimate)',
            includeInsurance: 'Include insurance (estimate)',
            updateResults: 'Update Results',
            paymentClosingCosts: 'Payment & closing costs',
            principalAndInterest: 'Principal and interest',
            taxes: 'Taxes',
            insurance: 'Insurance',
            applyLoanOnline: 'Apply for this loan online',
            meetWithMortgageExpert: 'Or, meet with a mortgage expert',
            meetWithMortgageExpertToLearnMore: 'Meet with a mortgage expert to learn more',
            totalClosingCosts: 'Total closing costs',
            lenderFees: 'Lender fees',
            loanOriginationFee: 'Loan Origination Fee',
            processingFee: 'Processing Fee',
            mortgagePoints: 'Mortgage Points',
            thirdPartyCosts: 'Third-party costs',
            creditReportFee: 'Credit Report Fee',
            titleFees: 'Title Fees',
            appraisal: 'Appraisal',
            constructionInspectionFees: 'Construction Inspection Fees',
            itemsDueAtClosing: 'Other items due at closing',
            interestPartialMonth: 'Interest for partial month',
            homeOwnersInsurance: 'Home owners insurance',
            propertyTaxes: 'Property taxes',
            tbd: 'TBD',
            apply: 'Apply',
            NationalGuardOrReserves: 'National Guard or Reserves',
            ActiveDuty: 'Active Duty',
            apr: 'APR',
            loanType: 'Loan type',
            adjustYourRate: 'Adjust your rate',
            rate: 'Rate',
            otherLoanTypesAvailable: 'Other loan types available',
            totalEstClosingCosts: 'Total est. closing costs',
            onlineQuoteNotFound: 'We are unable to provide an online quote based on the entered information. To discuss your mortgage options, please contact a Mountain America Mortgage Specialist at 1-800-277-7703. You may also try adjusting the quote information.',
            rateError: 'Our payment estimator is temporarily unavailable.',
        },
        es: {
            advancedDetails: 'Detalles adelantados',
            loanAssumptions: 'Supuestos de préstamo',
            Purchase: 'Compra',
            RefiCashout: 'Refinanciar retiro de efectivo',
            RefiRateTermLimitedCO: 'Refinanciar',
            InvestmentProperty: 'Propiedad de inversión',
            PrimaryResidence: 'Residencia principal',
            SecondHome: 'Segunda casa',
            Condo: 'Condominio',
            SingleFamily: 'Unifamiliar',
            Townhouse: 'Casa adosada',
            purchasePrice: 'Precio de compra',
            currentHomeValue: 'Valor actual de la vivienda',
            downPayment: 'Pago inicial',
            refinanceAmount: 'Monto de refinanciamiento',
            customizeRate: 'Personalice su tarifa',
            todaysRate: "Tasa actual",
            detailedQuote: 'Ver cotización detallada',
            per: 'por',
            month: 'mes',
            onApprovedCredit: 'Con crédito aprobado',
            includePropertyTax: 'Incluir impuesto a la propiedad (estimado)',
            includeInsurance: 'Incluir seguro (estimado)',
            updateResults: 'Actualizar resultado ',
            paymentClosingCosts: 'Pago y costos de cierre',
            principalAndInterest: 'Principal e interés',
            taxes: 'Impuestos',
            insurance: 'Seguro',
            applyLoanOnline: 'Solicitar este préstamo en línea',
            meetWithMortgageExpert: 'O bien, reúnase con un experto en hipotecas',
            meetWithMortgageExpertToLearnMore: 'Reúnase con un experto en hipotecas para más información',
            totalClosingCosts: 'Costos totales de cierre',
            lenderFees: 'Tarifas del prestamista',
            loanOriginationFee: 'Tarifa de originación del préstamo',
            processingFee: 'Tarifa de procesamiento',
            mortgagePoints: 'Puntos de hipoteca',
            thirdPartyCosts: 'Costos de terceros',
            creditReportFee: 'Tarifa de informe de crédito',
            titleFees: 'Tarifa del título',
            appraisal: 'Cotización',
            constructionInspectionFees: 'Tarifas de Inspección de Construcción',
            itemsDueAtClosing: 'Otros elementos adeudados al cierre',
            interestPartialMonth: 'Interés parcial mensual ',
            homeOwnersInsurance: 'Seguro para propietarios de casas',
            propertyTaxes: 'Impuestos de propiedad',
            tbd: 'Por determinar',
            apply: 'Solicitar',
            NationalGuardOrReserves: 'Guardia Nacional o Reservista',
            ActiveDuty: 'Servicio activo',
            apr: 'TAE',
            loanType: 'Tipo de préstamo',
            adjustYourRate: 'Ajuste su tasa',
            rate: 'Tasa',
            otherLoanTypesAvailable: 'Otros tipos de préstamos disponibles',
            totalEstClosingCosts: 'Total est. de costos al cierre',
            onlineQuoteNotFound: 'No podemos proporcionar una cotización en línea basada en la información ingresada. Para conversar sobre sus opciones de hipoteca, por favor contacte a un especialista en hipotecas de Mountain America al 1-800-277-7703. También puede intentar arreglar la información de la cotización.',
            rateError: 'Nuestro estimador de pagos está temporalmente fuera de servicio.',
        }
    }
    return translationStrings[lang];
}
